export default __webpack_public_path__ + "static/media/minus.42f69fdd.svg";